import { CartItem } from "./cartItem";

export class Cart {
    cartItems: CartItem[] = new Array();
    grandTotal: number;
}